import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from '../state/state';
import * as fromCard from '../state/selectors';

@Injectable()
export class BinNumberQuery {

  constructor(private store: Store<State>) { }

  get values(): Observable<{ binNumber: string, binFound: boolean, alternativeBin: boolean }> {
    return this.store.pipe(
      select(fromCard.getBinNumber)
    )
  }

}
